import { useState } from "react";

/**
 * 智能体/微场景相关状态 Hook
 */
const useAgentState = () => {
  const [agents, setAgents] = useState([]);
  const [currentAgentIndex, setCurrentAgentIndex] = useState(0);
  const [selectedMicroScene, setSelectedMicroScene] = useState(null);
  const [fullscreenAgent, setFullscreenAgent] = useState(null);
  const [selectedTraining, setSelectedTraining] = useState(null);

  // 重置智能体状态
  const resetAgentState = () => {
    setAgents([]);
    setCurrentAgentIndex(0);
    setSelectedMicroScene(null);
    setFullscreenAgent(null);
    setSelectedTraining(null);
  };

  return {
    agents,
    setAgents,
    currentAgentIndex,
    setCurrentAgentIndex,
    selectedMicroScene,
    setSelectedMicroScene,
    fullscreenAgent,
    setFullscreenAgent,
    selectedTraining,
    setSelectedTraining,
    resetAgentState,
  };
};

export default useAgentState;
